module.exports = __webpack_public_path__ + "img/neptune.a2b9a367.svg";